import { ArrowLeft01Icon, ArrowRight01Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import * as React from 'react';
import { useAppDispatch, useAppSelector } from '@/hooks';
import { useNavigate, useParams } from 'react-router-dom';
import { Form, Formik } from 'formik';
import {
  Box,
  Container,
  Paper,
  Typography,
  Button,
  Stepper,
  Step,
  StepLabel,
  Stack,
} from '@mui/material';
import Details from './steps/Details';
import Templates from './steps/Templates';
import Config from './steps/Config';
import { addMenu } from '../menu/slice';

const steps = [
  {
    title: 'Detalles',
    component: Details,
  },
  {
    title: 'Diseño',
    component: Templates,
  },
  {
    title: 'Configuración',
    component: Config,
  },
];

const NewMenuWizard = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const user = useAppSelector((state) => state.auth.user);
  const { organizationId } = useParams();
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set<number>());

  const isStepSkipped = (step: number) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  return (
    <Container sx={{ width: '100%', marginTop: 4 }}>
      <Paper sx={{ padding: 4 }}>
        <Typography variant="h1" sx={{ marginBottom: 3 }}>
          Crear Menú
        </Typography>
        <Stepper activeStep={activeStep}>
          {steps.map(({ title }, index) => {
            const stepProps: { completed?: boolean } = {};
            const labelProps: {
              optional?: React.ReactNode;
            } = {};

            if (isStepSkipped(index)) {
              stepProps.completed = false;
            }
            return (
              <Step key={title} {...stepProps}>
                <StepLabel {...labelProps}>{title}</StepLabel>
              </Step>
            );
          })}
        </Stepper>
        <Formik
          initialValues={{
            id: '',
            title: '',
            createdBy: user?.uid ?? '',
            template: '',
            isPublished: false,
            organization: organizationId,
          }}
          onSubmit={async (values) => {
            const response = await dispatch(addMenu(values));

            if (response.meta.requestStatus === 'fulfilled') {
              navigate(
                `/comercios/${organizationId}/menus/${response?.payload?.id}/editor`
              );
            }
          }}
        >
          {({ handleSubmit }) => (
            <Form>
              <>
                <Box sx={{ paddingTop: 4, paddingBottom: 4 }}>
                  {React.createElement(steps[activeStep].component)}
                </Box>
                <Stack
                  direction="row"
                  spacing={2}
                  justifyContent="space-between"
                >
                  <Button
                    color="inherit"
                    disabled={activeStep === 0}
                    onClick={handleBack}
                    sx={{ mr: 1 }}
                    size="large"
                    startIcon={<HugeiconsIcon icon={ArrowLeft01Icon} />}
                  >
                    Regresar
                  </Button>
                  <Button
                    endIcon={<HugeiconsIcon icon={ArrowRight01Icon} />}
                    onClick={
                      activeStep === steps.length - 1
                        ? handleSubmit
                        : handleNext
                    }
                  >
                    {activeStep === steps.length - 1
                      ? 'Finalizar'
                      : 'Continuar'}
                  </Button>
                </Stack>
              </>
            </Form>
          )}
        </Formik>
      </Paper>
    </Container>
  );
};

export default NewMenuWizard;
